import styled from 'styled-components';
import { Card as _Card } from 'antd';

export const Container = styled.div`
  h1 {
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--primary-text);
    text-align: left;
  }

  h2 {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--primary-text);
    margin-bottom: 0.5rem;
  }
`;

export const Content = styled.div`
  width: 100%;
`;

export const NoContent = styled.div`
  width: 100%;
  text-align: center;
  padding: 5rem;
`;

export const Card = styled(_Card)`
  background-color: var(--body-background);
  margin-bottom: 1rem;
  height: calc(100% - 1rem);
  border-radius: 12px;
  overflow: hidden;
`;

export const SprintInfo = styled.span`
  font-size: 0.8rem;
  color: var(--primary-text);
  margin-left: 0.5rem;
  font-weight: 400;
`;

export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.8rem;
  padding: 0.2rem 0;
  border-bottom: 1px solid #eee;

  a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    white-space: nowrap;
    color: #888;
  }
`;

export const Empty = styled.div`
  font-size: 0.8rem;
  color: #888;
`;

export const BarRow = styled.div`
  font-size: 0.8rem;
  margin-bottom: 0.4rem;

  div.label {
    display: flex;
    justify-content: space-between;
  }
`;
